import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeletionFormRequest as SchemaDeletionFormRequest } from '../schemas/DeletionFormRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Форма ОС при удалении магазина
 */
export const DeletionFormContentType = 'application/json' as const;
export type DeletionFormRequest = SchemaDeletionFormRequest;
export type DeletionFormResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': unknown;
    };
};
export type DeletionFormResponseSuccess = DeletionFormResponses['200']['application/json'];
export type DeletionFormSearchParams = undefined;
export type DeletionFormPathParameters = undefined;
export const DeletionFormUrl = '/deletion/form' as const;
export const DeletionFormMethod = 'POST' as const;
export const getDeletionFormUrl = (_params?: DeletionFormPathParameters) => DeletionFormUrl;
